import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si mi hijo no tiene diagnóstico?',
    a: 'Sí. Este protocolo está pensado para niños con alta sensibilidad, desregulación o sobrecarga, con o sin diagnóstico formal.'
  }, {
    q: '¿Necesito comprar equipo especial?',
    a: 'No. Puedes empezar con recursos simples y con lo que ya tienes en casa.'
  }, {
    q: '¿Esto reemplaza terapia o atención médica?',
    a: 'No. Es una herramienta práctica de apoyo para el día a día, no un sustituto de tratamiento profesional.'
  }, {
    q: '¿Está en español?',
    a: 'Sí. Todo el material está en español y pensado para mamás latinas en USA.'
  }, {
    q: '¿Cuándo recibo acceso?',
    a: 'Inmediatamente después de la compra.'
  }];
  return <section className="bg-[#FDF8F0] pt-6 pb-10 md:py-24 px-5" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-[#2D1F0E] mb-8" data-id="element-11">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-12">
          {faqs.map((faq, idx) => <div key={idx} className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${openIndex === idx ? 'border-[#4A6741] shadow-sm' : 'border-[#D4A853]/30'}`} data-id="element-13">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none min-h-[48px]" aria-expanded={openIndex === idx} data-id="element-14">
                <span className="text-base md:text-lg font-bold text-[#2D1F0E] pr-4" data-id="element-15">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#4A6741] flex-shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-16" />
              </button>

              <div className={`px-5 transition-all duration-200 ease-in-out ${openIndex === idx ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-17">
                <p className="text-[#6B5D4F] text-sm md:text-base leading-relaxed" data-id="element-18">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}